import {
  POST_GRP_BIRTH_DETAILS,
  POST_GRP_BIRTH_DETAILS_SUCCESS,
  POST_GRP_BIRTH_DETAILS_FAIL,
  GET_GRP_ALL_AI_REPORT_SUCCESS,
  GET_GRP_ALL_AI_REPORT_FAIL,
  GET_GRP_AI_REPORT_SUCCESS,
  GET_GRP_AI_REPORT_FAIL,
  GET_REPORT,
  GET_REPORT_SUCCESS,
  GET_REPORT_FAIL,
  GET_ALL_REPORTS,
  GET_ALL_REPORTS_SUCCESS,
  GET_ALL_REPORTS_FAIL,
  GET_ALL_REPORTS_FOR_GROUP_ADMIN,
  GET_ALL_REPORTS_FOR_GROUP_ADMIN_FAIL,
  GET_ALL_REPORTS_FOR_GROUP_ADMIN_SUCCESS,
  GET_BRANCHES_SUCCESS,
  GET_BRANCHES_FAIL,
  GET_BRANCHES,
  GET_GROUP_USERS,
  GET_GROUP_USERS_SUCCESS,
  GET_GROUP_USERS_FAIL,
  GET_GROUP_MASTERS_SUCCESS,
  GET_GROUP_MASTERS,
  GET_GROUP_MASTERS_FAIL
} from "./actionTypes"

import { RESULT_OK, RESULT_ERROR } from "store/baseActionTypes"

const INIT_STATE = {
  reportsPage: [],
  report: {},
  error: {},
  loading: false,
  actionResult: {},
  userBirthChartListPage: {},
  branches: [],
  groupUsers: [],
  groupMasters: []
}

const grpReports = (state = INIT_STATE, action) => {
  switch (action.type) {

    case POST_GRP_BIRTH_DETAILS:
      return {
        ...state,
        loading: true,
        birthDetail: action.payload,
      }

    case POST_GRP_BIRTH_DETAILS_SUCCESS:
      return {
        ...state,
        birthDetail: action.payload,
        actionResult: { action: POST_GRP_BIRTH_DETAILS, result: RESULT_OK, error: '' },
        loading: false,
      }

    case POST_GRP_BIRTH_DETAILS_FAIL:
      return {
        ...state,
        error: action.payload,
        actionResult: { action: POST_GRP_BIRTH_DETAILS, result: RESULT_ERROR, error: action.payload },
        loading: false,
      }

    case GET_GRP_ALL_AI_REPORT_SUCCESS:
      return {
        ...state,
        reportList: action.payload,
        actionResult: { action: GET_GRP_ALL_AI_REPORT, result: RESULT_OK, error: '' },
        loading: false,
      }

    case GET_GRP_ALL_AI_REPORT_FAIL:
      return {
        ...state,
        error: action.payload,
        actionResult: { action: GET_GRP_ALL_AI_REPORT, result: RESULT_ERROR, error: action.payload },
        loading: false,
      }

    case GET_ALL_REPORTS_FOR_GROUP_ADMIN_SUCCESS:
      return {
        ...state,
        reportList: action.payload,
        actionResult: { action: GET_ALL_REPORTS_FOR_GROUP_ADMIN, result: RESULT_OK, error: '' },
        loading: false,
      }

    case GET_ALL_REPORTS_FOR_GROUP_ADMIN_FAIL:
      return {
        ...state,
        error: action.payload,
        actionResult: { action: GET_ALL_REPORTS_FOR_GROUP_ADMIN, result: RESULT_ERROR, error: action.payload },
        loading: false,
      }

    case GET_BRANCHES:
      return {
        ...state,
        branches: []
      }

    case GET_BRANCHES_SUCCESS:
      return {
        ...state,
        branches: action.payload,
        actionResult: { action: GET_BRANCHES, result: RESULT_OK, error: '' },
        loading: false,
      }

    case GET_BRANCHES_FAIL:
      return {
        ...state,
        error: action.payload,
        actionResult: { action: GET_BRANCHES, result: RESULT_ERROR, error: action.payload },
        loading: false,
      }

    case GET_GROUP_USERS:
      return {
        ...state,
        groupUsers: []
      }

    case GET_GROUP_USERS_SUCCESS:
      return {
        ...state,
        groupUsers: action.payload,
        actionResult: { action: GET_GROUP_USERS, result: RESULT_OK, error: '' },
        loading: false,
      }

    case GET_GROUP_USERS_FAIL:
      return {
        ...state,
        error: action.payload,
        actionResult: { action: GET_GROUP_USERS, result: RESULT_ERROR, error: action.payload },
        loading: false,
      }

    case GET_GRP_AI_REPORT_SUCCESS:
      return {
        ...state,
        report: action.payload,
        actionResult: { action: GET_GRP_AI_REPORT, result: RESULT_OK, error: '' }
      }

    case GET_GRP_AI_REPORT_FAIL:
      return {
        ...state,
        error: action.payload,
        actionResult: { action: GET_GRP_AI_REPORT, result: RESULT_ERROR, error: action.payload }
      }

    case GET_ALL_REPORTS:
      return {
        ...state,
        loading: true
      }
    case GET_ALL_REPORTS_SUCCESS:
      return {
        ...state,
        userBirthChartListPage: action.payload,
        actionResult: { action: GET_ALL_REPORTS, result: RESULT_OK, error: '' },
        loading: false
      }

    case GET_ALL_REPORTS_FAIL:
      return {
        ...state,
        userBirthChartListPage: {},
        actionResult: { action: GET_ALL_REPORTS, result: RESULT_ERROR, error: action.payload },
        loading: false
      }
    case GET_REPORT:
      return {
        ...state,
        loading: true,
      }
    case GET_REPORT_SUCCESS:
      return {
        ...state,
        birthChart: action.payload,
        actionResult: { action: GET_REPORT, result: RESULT_OK, error: '' }
      }

    case GET_REPORT_FAIL:
      return {
        ...state,
        error: action.payload,
        actionResult: { action: GET_REPORT, result: RESULT_ERROR, error: action.payload }
      }

    case GET_GROUP_MASTERS:
      return {
        ...state,
        groupMasters: []
      }

    case GET_GROUP_MASTERS_SUCCESS:
      return {
        ...state,
        groupMasters: action.payload,
        actionResult: { action: GET_GROUP_MASTERS, result: RESULT_OK, error: '' },
        loading: false,
      }

    case GET_GROUP_MASTERS_FAIL:
      return {
        ...state,
        error: action.payload,
        actionResult: { action: GET_GROUP_MASTERS, result: RESULT_ERROR, error: action.payload },
        loading: false,
      }

    default:
      return state
  }
}

export default grpReports
